import { useEffect } from 'react'
import CTAButtonText from "../Common/CTAButtonText";
import LazyLoad from 'react-lazy-load';

function Hero({ pricing }) {
    useEffect(() => {
        const parallaxContainer = document.querySelector('.parallax-container');

        const handleScroll = () => {
            const scrolled = window.scrollY;
            parallaxContainer.style.transform = 'translateY(' + scrolled * 0.4 + 'px)';
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div className="hero-container">
            <div className="background">
                {/* <div class="bg-overlay" style={{ backgroundImage: "url(" + process.env.PUBLIC_URL + "/images/hero-bg-overlay.png)" }}></div> */}
                <div className="top-gradient"></div>
                <div className="parallax-container">
                    <LazyLoad offset={300} className="desktop">
                        <div className="hero-image" style={{ backgroundImage: "url(" + process.env.PUBLIC_URL + "/images/hero-image.png)" }}></div>
                    </LazyLoad>
                    <LazyLoad offset={300} className="mobile">
                        <div className="hero-image" style={{ backgroundImage: "url(" + process.env.PUBLIC_URL + "/images/mobile-hero.png)" }}></div>
                    </LazyLoad>
                </div>

                <div className="bottom-gradient"></div>
            </div>
            <div className="content">
                <h1>Home of Filipino Stories</h1>
                <div className="features">
                    <p>
                        <span className="text">Full Content Library</span>
                        <span className="dot"></span>
                        <span className="text">Live Channels and Program</span>
                        <span className="dot"></span>
                        <span className="text">SD and HD</span>
                        <span className="dot"></span>
                        <span className="text">Watch Up To 4 Devices</span>
                        <span className="dot"></span>
                        <span className="text">Watch Anywhere, Any Device</span>
                        <span className="dot"></span>
                        <span className="text">Cancel Anytime</span></p>
                    <p>Choose a plan that is right for you. Available in monthly and annual subscriptions.</p>
                </div>
                <div className="plans">
                    <div className="plan">
                        <p>Standard</p>
                        <span>Limited Ads</span>
                        {
                            pricing?.standard?.monthly &&
                            <span className="pricing">{pricing?.standard?.monthly}<span className="month-copy">/month</span></span>
                        }
                        
                    </div>
                    <div className="separator"></div>
                    <div className="plan">
                        <p>Premium</p>
                        <span>Ad-Free</span>
                        {
                            pricing?.premium?.monthly &&
                            <span className="pricing">{pricing?.premium?.monthly}<span className="month-copy">/month</span></span>
                        }
                        
                    </div>
                </div>
                <div className="cta-container">
                    <CTAButtonText context="Home" />
                </div>
            </div>

        </div>
    );
}

export default Hero;